import { APIService } from "../../../../network/api/APIService";


export const LogoutUser = () => {
  return APIService({
      endpoint: "/authentication/logout/",
      method: "POST"
  });
};